import types from './actionTypes';

const initialState = {
    importInProcess: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.BEGIN_IMPORT: {
            return {
                ...state,
                importInProcess: true,
            };
        }
        case types.SET_IN_PROCESS: {
            const { importInProcess } = action.payload;
            return {
                ...state,
                importInProcess,
            };
        }
        default:
            return state;
    }
};
